import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideZoneChangeDetection } from '@angular/core';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { httpLoaderFactory } from '../utils/httpLoaderFactory.util';
import { notificationInterceptor } from '../interceptors/notification.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { icons, ngZorroConfig } from '../utils/ngZorroConfig.util';
import { authInterceptor } from '../interceptors/auth.interceptor';
import { hr_HR, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import hr from '@angular/common/locales/hr';
import { registerLocaleData } from '@angular/common';
import { cookieAuthInterceptor } from '../interceptors/cookie-auth.interceptor';
import { refNotificationInterceptor } from '../interceptors/ref-notification.interceptor';

registerLocaleData(hr);

export const globalProviders = [
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideHttpClient(withInterceptors([notificationInterceptor, authInterceptor])),
  provideTranslateService({
    defaultLanguage: 'hr',
    loader: {
      provide: TranslateLoader,
      useFactory: httpLoaderFactory,
      deps: [HttpClient],
    },
  }),
  provideAnimationsAsync(),
  provideNzConfig(ngZorroConfig),
  provideNzI18n(hr_HR),
  provideNzIcons(icons)
];

export const referentProviders = [
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideHttpClient(withInterceptors([refNotificationInterceptor, cookieAuthInterceptor])),
  provideTranslateService({
    defaultLanguage: 'hr',
    loader: {
      provide: TranslateLoader,
      useFactory: httpLoaderFactory,
      deps: [HttpClient],
    },
  }),
  provideAnimationsAsync(),
  provideNzConfig(ngZorroConfig),
  provideNzI18n(hr_HR),
  provideNzIcons(icons),
];
